// Banner components for notifications and messages.
import { StyleSheet, View } from "react-native";
import { UtilityText } from "./text";
import { colorPinkHover, colorPinkPress, colorSurfaceDiscovery, colorSurfaceInfo, colorSurfaceWarning, colorTagEmphasized, colorTagVerified } from "./color";
import { HorizBox, HoverView, LoadingScreenStyle } from "./basics";
import { undefE, undefR, undefS } from "util/stdtypes";
import { useState, useEffect } from "react";


export function TopBanner({rightIcon=undefE, children}) {
    const s = TopBannerStyle;
    return <View style={s.topBanner}>
        <View style={s.body}>{children}</View>
        {rightIcon && <View style={s.rightIcon}>{rightIcon}</View>}
    </View>
}
const TopBannerStyle = StyleSheet.create({
    topBanner: {
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: colorSurfaceDiscovery,
        paddingHorizontal: 20,
        paddingVertical: 15
    },
    body: {
        flex: 1
    },
    rightIcon: {
        marginLeft: 10
    }
})


export function Banner({color=colorSurfaceWarning, children}) {
    const s = BannerStyle;
    return <View style={[s.banner, {backgroundColor: color}]}>
        {children} 
    </View>
}
const BannerStyle = StyleSheet.create({
    banner: {
        paddingHorizontal: 20,
        paddingVertical: 15,
        borderRadius: 8,
        overflow: "hidden",
    }
})

export function BannerMessage({label=undefS, text=undefS, formatParams=undefR, error=false}) {
    return <Banner color={error ? colorTagEmphasized : colorSurfaceInfo}>
        <UtilityText weight='medium' label={label} text={text} formatParams={formatParams} />
    </Banner>
}

export function ClickableBanner({testID=undefS, onPress, color=colorSurfaceWarning, hoverColor=colorPinkHover, pressColor=colorPinkPress, children}) {
    const s = ClickableBannerStyle;
    return <HoverView onPress={onPress} testID={testID}
                style={[s.banner, {backgroundColor: color}]} 
                hoverStyle={{backgroundColor: hoverColor}}
                pressedStyle={{backgroundColor: pressColor}}
            >
        <HorizBox center spread>
            {children}
        </HorizBox>
    </HoverView>
}
const ClickableBannerStyle = StyleSheet.create({
    banner: {
        paddingHorizontal: 20,
        paddingVertical: 15,
        borderRadius: 8
    }
})
export function LoadingScreen({ label = 'Loading...' }) {
    const [show, setShow] = useState(false);
    const s = LoadingScreenStyle;

    useEffect(() => {
        const timeout = setTimeout(() => setShow(true), 1000);
        return () => clearTimeout(timeout);
    }, []);

    if (show) {
        return <View style={s.outer}>
            {/* <UtilityText style={s.text} label={label} /> */}
            <Banner color={colorTagVerified}><UtilityText label={label} /></Banner>
        </View>;
    } else {
        return null;
    }
}
